import Button from '@atlaskit/button';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useLocation, useHistory } from "react-router-dom";



const MobileMenu = ({
  handleGoToHome,
  handleGoToMyRiderTrips,
  handleGoToMyDriverTrips,
  handleGoToMyRiderProfile,
  handleGoToMyDriverProfile,
  handleLogout
}) => {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <Button appearance="primary" onClick={() => setOpen(!open)}>
        ☰ Menu
      </Button>
      {open && (
        <div style={{
            marginTop: "0.5rem",
            background: "#e8effd",
            padding: "1rem",
            borderRadius: "8px",
            width: "100%",       
            boxSizing: "border-box" 
          }}>
          <Button appearance="subtle" onClick={handleGoToHome}>Home</Button><br />
          <Button appearance="subtle" onClick={handleGoToMyRiderTrips}>My Ride Requests</Button><br />
          <Button appearance="subtle" onClick={handleGoToMyDriverTrips}>My Ride Offers</Button><br />
          <Button appearance="subtle" onClick={handleGoToMyRiderProfile}>My Rider Profile</Button><br />
          <Button appearance="subtle" onClick={handleGoToMyDriverProfile}>My Driver Profile</Button><br />
          <Button appearance="subtle" onClick={() => { window.open("https://www.hourworld.org"); }}>hOurworld</Button><br />
          <Button appearance="primary" onClick={handleLogout}>Logout</Button>
        </div>
      )}
    </div>
  );
};



const NavBar = () => {
    const history = useHistory();
    const location = useLocation();
    const [riderID, setRiderID] = useState(null);
    const [driverID, setDriverID] = useState(null);
    
    useEffect(() => {
        setRiderID(window.sessionStorage.getItem("riderID"));
        setDriverID(window.sessionStorage.getItem("driverID"));
    }, []);
    
    if (location.pathname === "/login") {
        return <div style={{ padding: "30px", backgroundColor: "#f8f9fa" }}></div>
    }
    
    const bearerToken = window.sessionStorage.getItem("bearerToken");
    const eID = window.sessionStorage.getItem("eID");
    
    const handleGoToHome = () => history.push(`/home?eID=${eID}`);
    
    const handleGoToMyRiderTrips = () => {
        if (riderID !== null || window.sessionStorage.getItem("riderID") != null) {
        history.push("/rider-my-trips")
        }
    };
    
    const handleGoToMyDriverTrips = () => {
        if (driverID !== null || window.sessionStorage.getItem("driverID") != null) {
        history.push("/driver-my-trips")
        }
    };
    
    const handleGoToMyRiderProfile = () => {
        const id = riderID || window.sessionStorage.getItem("riderID");
        if (id != null) {
        history.push(`/rider-public-profile?riderID=${id}`);
        }
    };
    
    const handleGoToMyDriverProfile = () => {
        const id = driverID || window.sessionStorage.getItem("driverID");
        if (id != null) {
        history.push(`/driver-public-profile?driverID=${id}`);
        }
    };
    
    const handleLogout = async () => {
        const id = window.sessionStorage.getItem("userID");
        try {
        await axios.post(`https://iuhw-app.hourworld.org/user/${id}/logout`, null, {
            headers: { "Authorization": "Bearer " + bearerToken }
        });
        ["bearerToken", "userID", "eID", "memID", "riderID", "driverID"].forEach(key => window.sessionStorage.removeItem(key));
        history.push(`/login?eID=${eID}`);
        } catch (e) {
        console.log(e);
        }
    };
    
    return (
        <>
    <style>
        {`
        /* Mobile: show hamburger menu, hide desktop menu */
        .nav-mobile {
            display: block;
        }

        .nav-desktop {
            display: none;
        }

        /* Desktop: when screen is wider than 768px, do the opposite */
        @media (min-width: 768px) {
            .nav-mobile {
            display: none;
            }
            .nav-desktop {
            display: flex;
            gap: 1rem;
            align-items: center;
            }
        }
        `}
    </style>
   
        <nav className="navbar" style={{ padding: "1rem", backgroundColor: "#f8f9fa" }}>
        <div className="nav-desktop" style={{ paddingLeft: "43rem",  paddingTop:"1rem"}}>
            <Button appearance="subtle" onClick={handleGoToHome}>Home</Button>
            <Button appearance="subtle" onClick={handleGoToMyRiderTrips}>My Ride Requests</Button>
            <Button appearance="subtle" onClick={handleGoToMyDriverTrips}>My Ride Offers</Button>
            <Button appearance="subtle" onClick={handleGoToMyRiderProfile}>My Rider Profile</Button>
            <Button appearance="subtle" onClick={handleGoToMyDriverProfile}>My Driver Profile</Button>
            <Button appearance="subtle" onClick={() => { window.open("https://www.hourworld.org"); }}>hOurworld</Button>
            <Button appearance="primary" onClick={handleLogout}>Logout</Button>
        </div>
    
        <div className="nav-mobile" style={{ width: "100%" }} >
            <MobileMenu
            handleGoToHome={handleGoToHome}
            handleGoToMyRiderTrips={handleGoToMyRiderTrips}
            handleGoToMyDriverTrips={handleGoToMyDriverTrips}
            handleGoToMyRiderProfile={handleGoToMyRiderProfile}
            handleGoToMyDriverProfile={handleGoToMyDriverProfile}
            handleLogout={handleLogout}
            />
        </div>
        </nav>

    </>
    );
    };
    
export default NavBar;